import * as z from 'zod'

import { AlertsReportPayload } from './types'

export const alertsReportSchema = z.object({
  page: z.number().int().positive().default(1),
  size: z.number().int().positive().default(20)
}) as z.ZodType<AlertsReportPayload>
